import React, { Component } from 'react';
import {connect} from 'react-redux'
import {Button,Modal,Row,Col,Form,FormGroup,FormControl,InputGroup} from 'react-bootstrap'
import FontAwsome from 'react-fontawesome'
import ReportStore from 'stores/ReportStore'
import { Checkbox } from 'react-icheck'

class InvoiceModal extends Component {

    constructor(props) {
        super(props)

        this.state = {q:'',has_bn:true,doc:{},itemlist:[],check_itemlist:[],isCheckAll:false}
    }

    componentDidMount() {

    }

    componentWillReceiveProps(newProps) {
        if (newProps.show&&newProps.show!==this.props.show) {
            this.loadData(newProps.customerName,this.state.has_bn)
        }
    }

    loadData(customer_name,status) {
        let {genItemlist,docType} = this.props
        ReportStore.loadInvoiceListByCustomer(customer_name,status,(result)=>{
            let check_itemlist = []
            result.data.forEach((item,index)=>{
                let checkDup = -1
                if (docType==='billingnote')
                    checkDup = genItemlist.findIndex(x=>x.invoice_no===item.doc_no)
                else if (docType==='receiptvoucher')
                    checkDup = genItemlist.findIndex(x=>x.taxinvoice_no===item.doc_no)
                
                if (checkDup===-1) {
                    check_itemlist.push({doc_no:item.doc_no,isCheck:false})
                } else {
                    check_itemlist.push({doc_no:item.doc_no,isCheck:true})
                }
            })
            this.setState({itemlist:result.data,check_itemlist:check_itemlist})
            setTimeout(()=>{
                this.setState({isCheckAll:this.checkAll()})
            },100)
        })
    }

    getNumberFormat(value) {
        if(value===''||value===null||value===undefined||isNaN(value)){
          return ''
        }
        let _val = parseFloat(value)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    checkAll() {
        let {check_itemlist} = this.state
        let find = check_itemlist.findIndex(x=>x.isCheck===false)
		let check = false
		if (find===-1)
            check = true
        return check
    }

	onCheckboxChange(index) {
		let {check_itemlist} = this.state
		if (check_itemlist[index].isCheck)
			check_itemlist[index].isCheck = false
		else
			check_itemlist[index].isCheck = true

		this.setState({check_itemlist:check_itemlist,isCheckAll:this.checkAll()})
	}

	onCheckboxAllChange() {
		let {isCheckAll,check_itemlist} = this.state
		let new_list = []
		if (isCheckAll) {
			new_list = check_itemlist.map((item,index)=>{
				item.isCheck = false
				return item
			})
			this.setState({isCheckAll:false})
		} else {
			new_list = check_itemlist.map((item,index)=>{
				item.isCheck = true
				return item
			})
			this.setState({isCheckAll:true})
		}
		this.setState({check_itemlist:new_list})
	}

	onSelect() {
		let {check_itemlist,itemlist} = this.state
        let items = []
        itemlist.forEach((item,index)=>{
            if (check_itemlist[index].isCheck)
                items.push(item)
        })
        let datas = {itemlist:items}
		if (this.props.onSelect!==undefined)
            this.props.onSelect(datas)
    }
    
    onSearchCheckboxChange() {
        let {has_bn} = this.state
        has_bn = !has_bn
        this.setState({has_bn:has_bn})
        this.loadData(this.props.customerName,has_bn)
    }

    onTextChange(e) {
        this.setState({q:e.target.value})
    }

    onTextKeyPress(e) {
        if (e.charCode===13) {
            e.preventDefault()

            let {q,has_bn,itemlist} = this.state
            if (q==='') {
                this.loadData(this.props.customerName,has_bn)
            } else {
                let newitemlist = []
                itemlist.forEach((item,index)=>{
                    if (item.bill_no.search(q)!==-1)
                        newitemlist.push(item)
                })
                this.setState({itemlist:newitemlist})
                if (newitemlist.length===0) {
                    this.setState({isCheckAll:false})
                }
            }
        }
    }

    onHide() {
        this.setState({isCheckAll:false})
        this.props.onHide()
    }

    renderRowData() {
		let {itemlist,check_itemlist} = this.state
		if (itemlist.length===0) {
			return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
		} else {
			return(
				itemlist.map((item,index)=>{
					return(
						<tr key={index}>
							<td className='text-center'>
								<Checkbox
                                    onChange={this.onCheckboxChange.bind(this,index)}
                                    checked={check_itemlist[index].isCheck}
                                    checkboxClass="icheckbox_square-blue"
                                    increaseArea="20%"
                                    label={''}
                                >
                                </Checkbox>
							</td>
							<td className='text-center'>{item.bill_no}</td>
							<td className='text-center'>{item.work_no}</td>
							<td className='text-center'>{item.car_registration_no}</td>
                            <td className='text-center'>{item.brand}</td>
                            <td className='text-center'>{item.model}</td>
						</tr>
					)
				})
			)
		}
	}

    renderTable() {
		let {isCheckAll} = this.state
		return(
			<div className='table-responsive'>
				<table className='table table-hover table-bordered-solid table-gen-doc' style={{marginBottom:'0'}}>
					<thead>
						<tr>
							<th style={{width:'50px'}} className='text-center'>
								<Checkbox
                                    onChange={this.onCheckboxAllChange.bind(this)}
                                    checked={isCheckAll}
                                    checkboxClass="icheckbox_square-blue"
                                    increaseArea="20%"
                                    label={''}
                                >
                                </Checkbox>
							</th>
                            <th className='text-center' style={{width:'100px'}}>ใบแจ้งหนี้</th>
                            <th className='text-center' style={{width:'100px'}}>ใบงานเลขที่	</th>
                            <th className='text-center' style={{width:'150px'}}>ทะเบียนรถ</th>
                            <th className='text-center' style={{width:'120px'}}>ยี่ห้อ</th>
                            <th className='text-center' style={{width:'120px'}}>รุ่น</th>
						</tr>
					</thead>
					<tbody>
						{this.renderRowData()}
					</tbody>
				</table>
			</div>
		)
    }
    
    renderToolbar() {
        let {q,has_bn} = this.state
        return(
            <div>
                <Row>
                    <Col md={4}>
                        <Form>
                            <FormGroup>
                                <InputGroup>
                                    <FormControl placeholder='ค้นหา' value={q} onChange={this.onTextChange.bind(this)} onKeyPress={this.onTextKeyPress.bind(this)} />
                                    <InputGroup.Addon><FontAwsome name='search'/></InputGroup.Addon>
                                </InputGroup>  
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col md={4}>
                        <Form>
                            <FormGroup>
                                <Checkbox
                                    onChange={this.onSearchCheckboxChange.bind(this)}
                                    checked={has_bn}
                                    checkboxClass="icheckbox_square-blue"
                                    increaseArea="20%"
                                    label={' แสดงรายการที่ออกบิลรวมแล้ว'}
                                >
                                </Checkbox>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
            </div>            
        )
    }

    render() {
        let {show} = this.props
        return(
            <Modal show={show} onHide={this.onHide.bind(this)} dialogClassName="midwidth-dialog">
                <Modal.Header closeButton>
                    <Modal.Title>เลือกรายการจากใบแจ้งหนี้</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.renderToolbar()}
                    {this.renderTable()}
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' onClick={this.onSelect.bind(this)}><FontAwsome name='check' />&nbsp;เลือกรายการ</Button>
                    <Button onClick={this.onHide.bind(this)}><FontAwsome name='close' />&nbsp;ปิด</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}    

export default InvoiceModal = connect(
    (state) => ({messages: state.message.view.doc.GeneralDoc}),null,null,{withRef:true}
)(InvoiceModal);    



// WEBPACK FOOTER //
// ./src/view/doc/InvoiceModal.js